import { ColDef } from '@ag-grid-community/core'
import { customDateComparator } from '@utils/tableGridUtils'

export const RVSummaryTableColumns: ColDef[] = [
  {
    field: 'begin_date',
    filter: 'agDateColumnFilter',
    filterParams: {
      comparator: customDateComparator,
      buttons: ['reset'],
    },
    suppressMovable: true,
    lockPosition: true,
    pinned: 'left',
    valueGetter: (params: any) => {
      if (params.node.level === -1) {
        return 'Total'
      }
      return params.data.begin_date
    },
  },
  {
    field: 'port_total_return',
  },
  {
    field: 'bench_total_return',
  },
  {
    field: 'active_total_return',
  },
  {
    field: 'allocation_low',
    aggFunc: 'sum',
  },
  {
    field: 'selection_effect',
    aggFunc: 'sum',
  },
  {
    field: 'active_currency_return',
    aggFunc: 'sum',
  },
]
